export const Routes = {
  LANDING: '/',
  ARCHIVE: '/archive',
  PLACES: '/places',
};
